import toast from "react-hot-toast";
import { customDateFormat, formatDate } from "../../utils/utils";

const { clientAPI } = require("../client");
export const businessCategoryCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/businessCategory", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/businessCategory/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updateHiddenStatus: async (id) => {
    try {
      const response = await clientAPI(
        "put",
        `/businessCategory/updateHiddenStatus/${id}`,
      );
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getByCode: async (code) => {
    try {
      const response = await clientAPI("get", `/businessCategory/code/${code}`);
      return response;
    } catch (error) {
      console.error("get error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  export: async (entries, department, param) => {
    try {
      const options = {
        limit: entries,
        page: 1,
      };

      if (Number(department) === 0) {
        options.department = 0;
      } else if (Number(department) === 1) {
        options.department = 1;
      } else if (Number(department) === 2) {
        options.department = 2;
      } else if (Number(department) === 3) {
        options.department = 3;
      }

      if (param?.search) options.search = param.search;
      if (param?.branchId) options.branchId = param.branchId;
      if (param?.saleBlockId) options.saleBlockId = param.saleBlockId;
      if (param?.saleAreaId) options.saleAreaId = param.saleAreaId;
      if (param?.supportDepartmentId)
        options.supportDepartmentId = param.supportDepartmentId;
      if (param?.jobPositionId) options.jobPositionId = param.jobPositionId;
      if (param?.status !== null && param?.status !== undefined)
        options.status = param?.status;
      if (param?.statusIsProfileCompleted)
        options.isProfileCompleted = param?.statusIsProfileCompleted;
      if (param?.isBrokerDebtCertificate)
        options.isBrokerDebtCertificate = param?.isBrokerDebtCertificate;

      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI("get", `/employee?${queryParams}`);

      const dataExport = response?.items.map((item, index) => {
        return {
          code: item?.code || "",
          status: item?.status === 0 ? "Đang làm việc" : "Đã nghỉ làm",
          department:
            item?.department === 0
              ? "Hỗ trợ kinh doanh"
              : item?.department === 1
                ? "Kinh doanh"
                : "Giám đốc",
          // Loại nhân sự lấy theo businessCategoryId -> BusinessCategory.name
          // (Cộng tác viên / Elite nhận lương / Elite không lương / CVKD ...).
          businessCategory: item?.businessCategory?.name || "",
          fullName: item?.fullName || "",
          dateOfBirth: item?.dateOfBirth ? formatDate(item.dateOfBirth) : "",
          phone: item?.phone || "",
          email: item.email || "",
          currentAddress: item.currentAddress || "",
          identificationNumber: item?.identificationNumber || "",
          dateOfIdentification: item?.dateOfIdentification
            ? formatDate(item.dateOfIdentification)
            : "",
          placeOfIdentification: item.placeOfIdentification || "",
          permanentAddress: item.permanentAddress || "",
          taxCode: item.taxCode || "",
          bankAccount: item.bankAccount || "",
          bankName: item.bankName || "",
          gender:
            item?.gender === 0
              ? "Nam"
              : item?.gender === 1
                ? "Nữ"
                : item?.gender === 2
                  ? "Khác"
                  : "",
          supportDepartment: item.supportDepartment?.name || "",
          jobTitle: item?.jobTitle?.name || "",
          jobPosition: item.jobPosition?.name || "",
          saleBlock: item?.saleBlock?.name || "",
          saleArea: item?.saleArea?.name || "",
          branch: item?.branch?.name || "",
          startTime: item?.startTime ? formatDate(item.startTime) : "",
          endTime: item?.endTime ? formatDate(item.endTime) : "",
          remainingLeave:
            item?.leaveBalance?.remainingLeave !== null
              ? item?.leaveBalance?.remainingLeave || 0
              : "",
          compensatoryLeave:
            item?.leaveBalance?.compensatoryLeave !== null
              ? item?.leaveBalance?.compensatoryLeave || 0
              : "",
          isBrokerDebtCertificate: item?.isBrokerDebtCertificate
            ? "Đã có"
            : "Chưa có",
          isProfileCompleted: item?.isProfileCompleted
            ? "Hoàn thiện"
            : "Chưa hoàn thiện",
          referralCodeId: item.referralCodeId || "",

          // referral: item?.referralEmployee?.fullName || "",
          // employeeCode: item.employee?.code || "",
          // employeeName: item?.employee?.fullName || "",
          // guaranteeType: item.guaranteeType?.name || "",
          // guaranteeDate: item?.guaranteeDate
          //   ? formatDate(item.guaranteeDate)
          //   : "",
          // depositDate: item?.depositDate ? formatDate(item.depositDate) : "",
        };
      });

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
